/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6 3.99988V3.99988C6 2.34302 7.34315 0.999878 9 0.999878H17M14 8.99988H18M14 12.9999H18M10 10.9999C10 12.1044 9.10457 12.9999 8 12.9999C6.89543 12.9999 6 12.1044 6 10.9999C6 9.89531 6.89543 8.99988 8 8.99988C9.10457 8.99988 10 9.89531 10 10.9999Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="4"
				width="20"
				height="18"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22 11.9999C22 9.19962 22 7.79949 21.455 6.72993C20.9757 5.78912 20.2108 5.02421 19.27 4.54485C18.2004 3.99988 16.8003 3.99988 14 3.99988L10 3.99988C7.19974 3.99988 5.79961 3.99988 4.73005 4.54485C3.78924 5.02421 3.02434 5.78911 2.54497 6.72993C2 7.79948 2 9.19962 2 11.9999L2 13.9999C2 16.8001 2 18.2003 2.54497 19.2698C3.02433 20.2106 3.78924 20.9755 4.73005 21.4549C5.79961 21.9999 7.19974 21.9999 10 21.9999H14C16.8003 21.9999 18.2004 21.9999 19.27 21.4549C20.2108 20.9755 20.9757 20.2106 21.455 19.2698C22 18.2003 22 16.8001 22 13.9999V11.9999ZM8 12.9999C9.10457 12.9999 10 12.1044 10 10.9999C10 9.89531 9.10457 8.99988 8 8.99988C6.89543 8.99988 6 9.89531 6 10.9999C6 12.1044 6.89543 12.9999 8 12.9999Z"
				fill="currentColor"
			/>
			<path
				d="M14 9H18M14 13H18M6 4V4C6 2.34315 7.34315 1 9 1H17M10 11C10 12.1046 9.10457 13 8 13C6.89543 13 6 12.1046 6 11C6 9.89543 6.89543 9 8 9C9.10457 9 10 9.89543 10 11ZM10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V12C22 9.19974 22 7.79961 21.455 6.73005C20.9757 5.78924 20.2108 5.02433 19.27 4.54497C18.2004 4 16.8003 4 14 4H10C7.19974 4 5.79961 4 4.73005 4.54497C3.78924 5.02433 3.02433 5.78924 2.54497 6.73005C2 7.79961 2 9.19974 2 12V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.87094 3.27036C7.174 2.38585 8.01274 1.75 9 1.75L17 1.75C17.4142 1.75 17.75 1.41422 17.75 1C17.75 0.585789 17.4142 0.250003 17 0.250003L9 0.250001C7.13483 0.250001 5.5877 1.6117 5.29851 3.3952C4.7847 3.47565 4.36136 3.60067 3.98005 3.79497C3.03924 4.27433 2.27433 5.03923 1.79497 5.98004C1.25 7.0496 1.25 8.44973 1.25 11.25L1.25 14.75C1.25 17.5503 1.25 18.9504 1.79496 20.02C2.27433 20.9608 3.03923 21.7257 3.98005 22.205C5.0496 22.75 6.44973 22.75 9.24997 22.75L9.25 22.75L14.75 22.75L14.75 22.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75L22.75 11.25L22.75 11.25C22.75 8.44973 22.75 7.0496 22.205 5.98005C21.7257 5.03924 20.9608 4.27433 20.02 3.79497C18.9504 3.25 17.5503 3.25 14.7501 3.25L14.7501 3.25L14.75 3.25L14.75 3.25L9.25 3.25C8.31381 3.25 7.53411 3.25 6.87094 3.27036ZM8 8.25C6.48121 8.25 5.25 9.48121 5.25 11C5.25 12.5188 6.48121 13.75 8 13.75C9.51878 13.75 10.75 12.5188 10.75 11C10.75 9.48121 9.51878 8.25 8 8.25ZM14 8.25C13.5858 8.25 13.25 8.58578 13.25 9C13.25 9.41421 13.5858 9.75 14 9.75L18 9.75C18.4142 9.75 18.75 9.41421 18.75 9C18.75 8.58578 18.4142 8.25 18 8.25L14 8.25ZM14 12.25C13.5858 12.25 13.25 12.5858 13.25 13C13.25 13.4142 13.5858 13.75 14 13.75L18 13.75C18.4142 13.75 18.75 13.4142 18.75 13C18.75 12.5858 18.4142 12.25 18 12.25L14 12.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 10.75V10.3V10.3C22 9.09181 22 8.48771 21.8961 7.98606C21.4918 6.03373 19.9663 4.50819 18.0139 4.10389C17.5123 4 16.9082 4 15.7 4H10C7.19974 4 5.79961 4 4.73005 4.54497C3.78924 5.02433 3.02433 5.78924 2.54497 6.73005C2 7.79961 2 9.19974 2 12V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H15.7C16.9082 22 17.5123 22 18.0139 21.8961C19.9663 21.4918 21.4918 19.9663 21.8961 18.0139C22 17.5123 22 16.9082 22 15.7V15.7V15.25M6 4V4C6 2.34315 7.34315 1 9 1H17M14 9H18M14 13H18M10 11C10 12.1046 9.10457 13 8 13C6.89543 13 6 12.1046 6 11C6 9.89543 6.89543 9 8 9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M6 4V4C6 2.34315 7.34315 1 9 1H17M14 9H18M14 13H18M10 11C10 12.1046 9.10457 13 8 13C6.89543 13 6 12.1046 6 11C6 9.89543 6.89543 9 8 9C9.10457 9 10 9.89543 10 11ZM10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V12C22 9.19974 22 7.79961 21.455 6.73005C20.9757 5.78924 20.2108 5.02433 19.27 4.54497C18.2004 4 16.8003 4 14 4H10C7.19974 4 5.79961 4 4.73005 4.54497C3.78924 5.02433 3.02433 5.78924 2.54497 6.73005C2 7.79961 2 9.19974 2 12V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 3.25C6.44974 3.25 5.04961 3.25 3.98005 3.79497C3.03924 4.27433 2.27434 5.03924 1.79497 5.98005C1.25 7.04961 1.25 8.44974 1.25 11.25L1.25 14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V11.25C22.75 8.44974 22.75 7.04961 22.205 5.98005C21.7257 5.03924 20.9608 4.27434 20.02 3.79497C18.9504 3.25 17.5503 3.25 14.75 3.25L9.25 3.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.25 3.5C5.25 1.70508 6.70507 0.25 8.5 0.250001L17 0.250002C17.4142 0.250002 17.75 0.585788 17.75 1C17.75 1.41422 17.4142 1.75 17 1.75L8.5 1.75C7.5335 1.75 6.75 2.5335 6.75 3.5L6.75 4C6.75 4.41422 6.41421 4.75 6 4.75C5.58579 4.75 5.25 4.41422 5.25 4L5.25 3.5ZM5.25 11C5.25 9.48122 6.48122 8.25 8 8.25C9.51878 8.25 10.75 9.48122 10.75 11C10.75 12.5188 9.51878 13.75 8 13.75C6.48122 13.75 5.25 12.5188 5.25 11ZM13.25 9C13.25 8.58579 13.5858 8.25 14 8.25L18 8.25C18.4142 8.25 18.75 8.58579 18.75 9C18.75 9.41422 18.4142 9.75 18 9.75L14 9.75C13.5858 9.75 13.25 9.41422 13.25 9ZM13.25 13C13.25 12.5858 13.5858 12.25 14 12.25L18 12.25C18.4142 12.25 18.75 12.5858 18.75 13C18.75 13.4142 18.4142 13.75 18 13.75L14 13.75C13.5858 13.75 13.25 13.4142 13.25 13Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
